var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        value: _vm.valueTitle,
        size: _vm.size,
        disabled: _vm.disabled,
        clearable: _vm.clearable,
        placeholder: _vm.placeholderText,
      },
      on: { clear: _vm.clearHandle },
    },
    [
      _c(
        "el-option",
        {
          staticClass: "options",
          attrs: { value: _vm.valueTitle, label: _vm.valueTitle },
        },
        [
          _c("el-tree", {
            ref: "selectTree",
            attrs: {
              id: "tree-option",
              accordion: _vm.accordion,
              data: _vm.optionData,
              "show-checkbox": _vm.showCheckbox,
              props: _vm.props,
              "highlight-current": "",
              "node-key": _vm.props.value,
              "default-expanded-keys": _vm.defaultExpandedKey,
            },
            on: {
              "check-change": _vm.handleCheckChange,
              "node-click": _vm.handleNodeClick,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }